import { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import { Buffer } from "buffer";

const BackendUname = process.env.REACT_APP_BACKEND_API_USERNAME;
const BackendPwd = process.env.REACT_APP_BACKEND_API_PASSWORD;

const authHeader = {
  Authorization: `Basic ${Buffer.from(
    `${BackendUname}:${BackendPwd}`,
    "utf8",
  ).toString("base64")}`,
};

const UploadUsersPopup = ({ apiUrl, createdBy, onClose }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [results, setResults] = useState([]);
  const [errors, setErrors] = useState([]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResults([]);
    setErrors([]);
  };

  const downloadTemplate = () => {
    const templateData = [
      {
        UserName: "JMSUSER01",
        CustomerNo: "C0001",
        CustomerName: "Example Company",
        Email: "user@example.com",
        PhoneNo: "0700000000",
        isAdmin: "USER",
        Blocked: false,
      },
    ];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(templateData);
    ws["!cols"] = [
      { wch: 16 },
      { wch: 14 },
      { wch: 24 },
      { wch: 28 },
      { wch: 14 },
      { wch: 12 },
      { wch: 10 },
    ];
    XLSX.utils.book_append_sheet(wb, ws, "Users Template");
    XLSX.writeFile(wb, "users_upload_template.xlsx");
  };

  const generateRandomPassword = () => {
    const chars =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < 12; i += 1) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    setUploading(true);
    setResults([]);
    setErrors([]);

    try {
      const reader = new FileReader();
      reader.onload = async (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(ws);

        if (!data || data.length === 0) {
          setErrors([{ row: "-", error: "File is empty or invalid format." }]);
          setUploading(false);
          return;
        }

        const uploaded = [];
        const failed = [];

        for (const [index, row] of data.entries()) {
          const userName = row.UserName || row.userName;
          const customerNo = row.CustomerNo || row.customerNo;
          const customerName = row.CustomerName || row.customerName;
          const email = row.Email || row.email;

          if (!userName && !customerNo && !email) {
            continue;
          }

          if (!userName || !customerNo || !customerName || !email) {
            failed.push({
              row: index + 2,
              error: "Missing required fields",
            });
            continue;
          }

          const payload = {
            userName,
            customerNo,
            customerName,
            isAdmin: row.isAdmin || row.IsAdmin || "USER",
            blocked: row.Blocked ?? row.blocked ?? false,
            phoneNo: row.PhoneNo || row.phoneNo || "",
            email,
            firstLogin: true,
            createdBy,
            password: generateRandomPassword(),
          };

          try {
            const res = await axios.post(apiUrl, payload, {
              headers: authHeader,
            });
            if (res.data?.success) {
              uploaded.push(payload);
            } else {
              failed.push({
                row: index + 2,
                error: res.data?.message || res.data?.error || "Upload failed",
              });
            }
          } catch (err) {
            failed.push({
              row: index + 2,
              error:
                err.response?.data?.error ||
                err.response?.data?.message ||
                err.message,
            });
          }
        }

        setResults(uploaded);
        setErrors(failed);
        setUploading(false);
      };

      reader.readAsBinaryString(file);
    } catch (_error) {
      setErrors([{ row: "-", error: "Failed to process file." }]);
      setUploading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: "600px",
          maxHeight: "80vh",
          overflowY: "auto",
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
        }}
      >
        <h3 style={{ marginBottom: "10px" }}>Upload Users</h3>
        <div style={{ marginBottom: "15px" }}>
          <button
            type="button"
            onClick={downloadTemplate}
            style={{
              padding: "6px 14px",
              border: "1px solid #28a745",
              color: "#28a745",
              borderRadius: "4px",
              cursor: "pointer",
              backgroundColor: "transparent",
              marginBottom: "10px",
            }}
          >
            Download Excel Template
          </button>
          <p style={{ fontSize: "12px", color: "#666", margin: 0 }}>
            Download the template file with the correct format for uploading
            users.
          </p>
        </div>

        <input
          type="file"
          accept=".xlsx, .xls, .csv"
          onChange={handleFileChange}
          style={{ marginBottom: "10px", width: "100%" }}
        />

        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <button
            type="button"
            onClick={handleUpload}
            disabled={uploading}
            className="express-list-btn"
            style={{
              padding: "6px 14px",
              border: "1px solid maroon",
              color: "grey",
              borderRadius: "4px",
              cursor: uploading ? "not-allowed" : "pointer",
            }}
          >
            {uploading ? "Uploading..." : "Upload"}
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "6px 14px",
              border: "1px solid #999",
              color: "grey",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>

        {results.length > 0 && (
          <div style={{ marginTop: "15px" }}>
            <h4 style={{ color: "green" }}>
              Uploaded Successfully ({results.length})
            </h4>
            <ul>
              {results.map((r, i) => (
                <li key={i}>{r.userName}</li>
              ))}
            </ul>
          </div>
        )}

        {errors.length > 0 && (
          <div style={{ marginTop: "15px" }}>
            <h4 style={{ color: "red" }}>Errors ({errors.length})</h4>
            <table
              border="1"
              cellPadding="6"
              style={{ borderCollapse: "collapse", width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Row</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {errors.map((err, i) => (
                  <tr key={i}>
                    <td>{err.row}</td>
                    <td>{err.error}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadUsersPopup;
